import { ComponentActions } from '../../../../../../../../apps/web-client/src/screens/Platform/admin-ui-screen/admin-ui-object/tabs/admin-ui-lifecycle/admin-ui-lifecycle-details/components/admin-ui-lifecycle-details-stages/components/stage-properties/components/component-actions/component-actions.component';
import { RenderConditionProps } from './render-conditions.model';

export const RenderConditionsView = ({
  objectOptions,
  formPath,
}: RenderConditionProps) => {
  return (
    <ComponentActions
      IsLoadingActionData={false}
      actionsOptions={[]}
      hideActions
      formPath={formPath}
      objectOptions={objectOptions}
      ruleLabel="Criteria"
      isSingleLayout
    />
  );
};
